/* @flow */

import { rem } from 'polished';

import { tintDuration } from '@e180/ui/lib/token/animation';
import { successColor, darkSuccessColor } from '@e180/ui/lib/token/color';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    fill: successColor,

    textDecoration: 'none',

    transition: `fill ${tintDuration}`,

    '&:hover': {
      fill: darkSuccessColor,
    },
  },
  circle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 80,
    height: 80,
    margin: '0 auto 12px',

    border: `solid 6px ${successColor}`,
    borderRadius: '50%',

    transition: `border-color ${tintDuration}`,

    '$root:hover &': {
      borderColor: darkSuccessColor,
    },
  },
  check: {
    width: 34,
    height: 26,
  },
  message: {
    color: successColor,

    fontSize: rem(22, baseFontSize),
    fontWeight: 600,
    lineHeight: 24 / 22,
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',

    transition: `color ${tintDuration}`,

    '$root:hover &': {
      color: darkSuccessColor,
    },
  },
};
